const setInsuranceFor$ = 'directOrderRecurring/setInsuranceFor$';

const SET_INSURANCE_QUANTITY = 'directOrderRecurring/SET_INSURANCE_QUANTITY';

const CLEAN_INSURANCE = 'directOrderRecurring/CLEAN_INSURANCE';

export default {
  setInsuranceFor$,
  SET_INSURANCE_QUANTITY,
  CLEAN_INSURANCE,
};
